<template>
  <div class="table2">
    <el-table :data="tableData2" border style="width: 100%" header-row-class-name="back_hui">
        <el-table-column prop="data" label="序号" width="100" align="center"></el-table-column>
        <el-table-column prop="data1" label="持有人" align='left'></el-table-column>
        <el-table-column prop="data2" label="持有数量(万张)" width="120" align="center"></el-table-column>
        <el-table-column prop="data3" label="持有比例" width="120" align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
    data(){
        return {
            tableData2:[
                {
                    data:'1',
                    data1:'上海浦东发展银行股份有限公司-易方达裕祥回报债券型证券投资基金',
                    data2:'104.64',
                    data3:'6.39%'
                },
                {
                    data:'2',
                    data1:'华鑫国际信托有限公司-华鑫信托·智度投资16号单一资金信托',
                    data2:'104.64',
                    data3:'2.14%'
                },
                {
                    data:'3',
                    data1:'贵州省国有资本运营有限责任公司',
                    data2:'104.64',
                    data3:'0.22%'
                },
            ]
        }
    }
}
</script>

<style scoped>
.table2{
    margin-top: 24px;
}
.el-table /deep/ th {
  background-color: #f8f9fd !important;
  /* text-align: center; */
  height: 56px;
}
.el-table /deep/ td {
  height: 72px;
}
</style>